export default "__VITE_ASSET__BFcsJs40__"